var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaiver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1277 -402) translate(1277 402)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#32325D",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M6.19 12.415L7.583 7.42c.057-.192.13-.483.216-.875.086-.391.148-.71.187-.955.019.16.074.448.167.86.092.413.168.728.23.947l1.427 5.02h1.497L13.5 4h-1.393L10.91 8.893c-.219.848-.357 1.546-.415 2.095-.15-.91-.291-1.593-.426-2.05L8.665 4H7.3L5.93 8.916c-.07.25-.146.575-.23.978-.085.403-.148.768-.19 1.094-.081-.603-.215-1.297-.403-2.084L3.905 4H2.5l1.105 4.202 1.088 4.213H6.19z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiver);
export default __webpack_public_path__ + "static/media/waiver.4b024eb00b589a6416abbd91dd2c50b7.svg";
export { ForwardRef as ReactComponent };